import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'error-notfication',
  standalone: true,
  imports: [MatDialogModule,CommonModule],
  templateUrl: './error-notfication.component.html',
  styleUrl: './error-notfication.component.scss'
})
export class ErrorNotficationComponent {
  message: string = ""
  title:string=""
  action:string=""
  actionType: string="add"
  cancelButtonText = "Cancel"
  cssClass = ""
  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private readonly dialogRef: MatDialogRef<ErrorNotficationComponent>) {
    if (data) {
      
      this.message = data.message;
      this.title= data.title;
      this.action = data.actionType
      this.cssClass = data.cssClass
    }
    this.dialogRef.updateSize('300vw','300vw')
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

}
